<template>
    <div>
        <el-dialog title="登录口令" :visible.sync="dialogVisible" width="800px" :before-close="handleClose">
            <el-button type="primary" style="margin-bottom: 10px" @click="addCommand">新增口令</el-button>
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="code" label="口令"> </el-table-column>
                <el-table-column prop="shop_id" label="归属门店">
                    <template>
                        {{ shopName }}
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="text" @click="removeCommand(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="downXlex">下 载</el-button>
            </span>
        </el-dialog>

        <el-dialog title="新增口令" :visible.sync="addDialogVisible" width="500px" :before-close="addHandleClose">
            <div>
                <el-form ref="form" :model="form">
                    <el-radio-group v-model="form.generate_type">
                        <el-radio label="random">随机生成</el-radio>
                        <el-form-item label="口令长度" style="margin-left: 30px; margin-top: 20px; width: 100%">
                            <el-input
                                :disabled="form.generate_type !== 'random'"
                                v-model="form.length"
                                type="number"
                                placeholder="请输入数字"
                                style="width: 300px !important"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="生成数量" style="margin-left: 30px; width: 100%">
                            <el-input
                                :disabled="form.generate_type !== 'random'"
                                v-model="form.count"
                                type="number"
                                placeholder="请输入数字"
                                style="width: 300px !important"
                            ></el-input>
                        </el-form-item>
                        <el-radio label="manual">手动输入</el-radio>
                        <el-form-item label="口令内容" style="margin-left: 30px; margin-top: 20px; width: 100%">
                            <el-input
                                :disabled="form.generate_type !== 'manual'"
                                maxlength="9"
                                v-model="form.code"
                                placeholder="小于10位，大小写字母+数字"
                                clearable
                                style="width: 300px !important"
                            ></el-input>
                        </el-form-item>
                    </el-radio-group>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addHandleClose">取 消</el-button>
                <el-button type="primary" @click="submit" :loading="submitLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { request } from '@/common/request';
import XLSX from 'xlsx';
export default {
    components: {
        Pagination
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: ''
        },
        shopName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tableData: [],
            queryParams: {
                shop_id: '',
                page: 1,
                pagesize: 10
            },
            pageInfo: {},

            addDialogVisible: false,
            form: {
                generate_type: 'random',
                code: '',
                length: null,
                count: null
            },

            submitLoading: false
        };
    },
    watch: {
        dialogVisible: {
            handler(val) {
                if (val) {
                    this.queryParams.shop_id = this.id;
                    this.getList();
                }
            }
        }
    },
    methods: {
        getList() {
            this.loading = true;
            request.get('/account/merchant/hotfan/shop/authCodes', this.queryParams).then((ret) => {
                if (ret.code == 1) {
                    this.tableData = ret.data.list;
                    this.pageInfo = ret.data;
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },

        // 删除口令
        removeCommand(row) {
            this.$confirm('确认删除该口令?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    request.post(`/account/merchant/hotfan/shop/authCode/delete?id=${row.id}`).then((ret) => {
                        if (ret.code == 1) {
                            this.$message.success('删除成功');
                            this.getList();
                        } else {
                            this.$message.error(ret.msg);
                        }
                    });
                })
                .catch(() => {});
        },

        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            this.getList();
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            this.getList();
        },
        handleClose() {
            this.$emit('update:dialogVisible', false);
        },

        addHandleClose() {
            this.addDialogVisible = false;
        },

        addCommand() {
            this.form = {
                generate_type: 'random',
                code: '',
                length: null,
                count: null
            };
            this.addDialogVisible = true;
        },

        submit() {
            const regex = /^(?=.{1,9}$)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]*$/;
            if (this.form.generate_type === 'manual' && !regex.test(this.form.code))
                return this.$message.error('请输入1-9位，且包含大小写字母+数字的字符');
            let data = {};
            if (this.form.generate_type === 'manual') {
                data = {
                    code: this.form.code,
                    generate_type: this.form.generate_type,
                    shop_id: this.id
                };
            } else {
                data = {
                    length: this.form.length,
                    count: this.form.count,
                    generate_type: this.form.generate_type,
                    shop_id: this.id
                };
            }

            this.submitLoading = true;
            request.post('/account/merchant/hotfan/shop/authCode/generate', data).then((ret) => {
                if (ret.code == 1) {
                    this.$message.success('新增成功');
                    this.getList();
                    this.addDialogVisible = false;
                    this.submitLoading = false;
                } else {
                    this.submitLoading = false;
                    this.$message.error(ret.msg);
                }
            });
        },

        downXlex() {
            if (!this.tableData.length) {
                this.$message.error('无可下载内容');
                return;
            }

            let list = [];
            for (let i of this.tableData) {
                list.push({
                    口令: i.code,
                    归属门店: this.shopName
                });
            }

            // 创建工作簿
            const workbook = XLSX.utils.book_new();

            // 创建工作表
            const worksheet = XLSX.utils.json_to_sheet(list);

            // 将工作表添加到工作簿
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // 将工作簿保存为Blob对象
            const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // 创建下载链接并触发下载操作
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = '口令列表.xlsx'; // 设置下载文件的文件名
            document.body.appendChild(link);
            link.click(); // 触发下载操作
            document.body.removeChild(link);
        }
    }
};
</script>

<style lang="scss" scoped>
.el-radio-group {
    width: 100%;
}

.el-form-item__label {
    color: #333 !important;
}
</style>